<template>
  <ul class="mt-2">
    <li v-for="value in refObj" :key = "value.recase_id">
      <p  style="width:100%;">
        <router-link :to="`/case/detail/${value.recase_id}`" :title="value.recase_title">{{ value.recase_title }}</router-link>
      <span>{{ moment(created).format("YYYY-MM-DD") }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
import base from '@/core/base.js'
export default {
  name: 'Case',
  mixins: [base]
}
</script>
